'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../p3.js');

var _getMuiTheme = require('material-ui/styles/getMuiTheme');

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _colorManipulator = require('material-ui/utils/colorManipulator');

var _colors = require('material-ui/styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @type Global localized variables
 */
var p3 = _extends({}, _jquery2.default.PhaseThree);
var theme = p3.theme || {};
var color = theme.primary_color || '#2196F3';
var color2 = theme.primary_color;
var darker = (0, _colorManipulator.darken)(color, .5);
var lighter = (0, _colorManipulator.lighten)(color, .9);
var luma = (0, _colorManipulator.getLuminance)(color);
var textColor = luma > .5 ? (0, _colorManipulator.darken)(color, .9) : (0, _colorManipulator.lighten)(color, .99);

/**
 * Convert a hex string to an RGB value
 *
 * @param string color The hex code
 * @return object RGB equivalent
 */
var hexToRgb = function hexToRgb(color) {
    if (color.length === 4) {
        var extendedColor = '#';
        for (var i = 1; i < color.length; i++) {
            extendedColor += color.charAt(i) + color.charAt(i);
        }
        color = extendedColor;
    }

    var values = {
        r: parseInt(color.substr(1, 2), 16),
        g: parseInt(color.substr(3, 2), 16),
        b: parseInt(color.substr(5, 2), 16)
    };

    return values;
};

/**
 * Blend two colors together.
 *
 * @param string c1 The first color
 * @param string c2 The second color
 * @param float i The blend intensity
 * @return {*}
 */
var colorBlend = function colorBlend(c1, c2, i) {

    // Declare and initialize
    var rgb1 = hexToRgb(c1);
    var rgb2 = hexToRgb(c2);
    i = i || .5;

    // Secure the channels
    var ch = {
        r: parseInt(rgb1.r * i + rgb2.r * (1 - i)),
        g: parseInt(rgb1.g * i + rgb2.g * (1 - i)),
        b: parseInt(rgb1.b * i + rgb2.b * (1 - i))

        // Process our color blends
    };var rgb = 'rgb(' + ch.r + ',' + ch.g + ',' + ch.b + ')';
    var dec = (0, _colorManipulator.decomposeColor)(rgb);
    var hex = (0, _colorManipulator.convertColorToString)(dec);

    // Return our hex value
    return hex;
};

/**
 * Retrieve a theme set.
 *
 * @param string theme The key of the theme set
 * @return object The selected theme
 */
var getThemeSet = function getThemeSet(theme, palette) {
    // Declare and initialize
    var palette = palette || {};
    var p1 = palette.primary_color || color;
    var p2 = palette.secondary_color || color2;
    var luma = (0, _colorManipulator.getLuminance)(p1);
    var p1alt = luma > .2 ? (0, _colorManipulator.darken)(p1, .05) : (0, _colorManipulator.lighten)(p1, .1);
    var p1text = luma > .5 ? (0, _colorManipulator.darken)(p1, .6) : (0, _colorManipulator.lighten)(p1, .99);
    var blendLevel = .65;

    var themes = {
        standard: {
            appBar: {
                zIndex: 1000,
                textColor: p1text || textColor
            },
            raisedButton: {
                primaryTextColor: p1text || textColor
            },
            textField: {
                floatingLabelColor: 'rgba(0,0,0,.56)'
            },
            palette: _defineProperty({
                requiredRed: _colors.red400,
                requiredRedHover: _colors.red300,
                fullWhite: _colors.fullWhite,
                canvasColor: _colors.fullWhite,
                canvasDarkerColor: (0, _colorManipulator.darken)(_colors.fullWhite, .05),
                secondaryTextColor: _colors.grey600,
                backgroundColor: _colors.grey50,
                primary1Color: p1 || _colors.blue500,
                primary1ColorFade: (0, _colorManipulator.fade)(p1, 0),
                primary1ColorLighter: (0, _colorManipulator.fade)(p1, .1),
                primary1ColorMid: (0, _colorManipulator.fade)(p1, .4),
                primary1ColorAlt: p1alt,
                primary1Text: p1text || textColor,
                pickerHeaderColor: p1 || _colors.blue500,
                accent1Color: p1 || _colors.blue500,
                disabledColor: _colors.grey400,
                lineColor: _colors.grey300,
                secondaryIconColor: _colors.grey500,
                borderColor: _colors.grey300,
                textColor: 'rgba(0,0,0,.86)'
            }, 'secondaryTextColor', _colors.grey500)
        },
        dark: {
            appBar: {
                textColor: p1text || textColor
            },
            raisedButton: {
                primaryTextColor: p1text || textColor
            },
            tabs: {
                selectedTextColor: _colors.fullWhite
            },
            textField: {
                floatingLabelColor: 'rgba(255,255,255,.56)'
            },
            palette: _defineProperty({
                requiredRed: _colors.red400,
                requiredRedHover: _colors.red300,
                backgroundColor: (0, _colorManipulator.darken)('#303030', .33),
                primary1Color: p1 || _colors.blue500,
                primary1ColorFade: (0, _colorManipulator.fade)(p1, 0),
                primary1ColorLighter: (0, _colorManipulator.fade)(p1, .2),
                primary1ColorAlt: p1alt,
                primary1Text: p1text || textColor,
                accent1Color: p1 || _colors.blue500,
                canvasColor: '#303030',
                canvasDarkerColor: (0, _colorManipulator.lighten)('#303030', .1),
                textColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.8),
                secondaryTextColor: _colors.grey500,
                alternateTextColor: '#303030',
                pickerHeaderColor: p1 || _colors.blue500,
                borderColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.3),
                disabledColor: _colors.grey700,
                clockCircleColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.12),
                lineColor: _colors.grey700,
                secondaryIconColor: _colors.grey700
            }, 'borderColor', _colors.grey700)
        },
        background: {
            bg: {
                background: 'url(https://source.unsplash.com/random/2560x1440)'
            },
            drawer: {
                backgroundColor: 'rgba(255,255,255,.5)'
            },
            palette: {
                fullWhite: _colors.fullWhite,
                canvasColor: _colors.fullWhite,
                canvasDarkerColor: _colors.grey50,
                backgroundColor: _colors.grey50,
                primary1Color: p1 || _colors.blue500,
                primary1ColorAlt: p1alt,
                primary1Text: p1text || textColor,
                accent1Color: p1 || _colors.blue500,
                disabledColor: _colors.grey400
            }
        }
    };

    // Select the correct theme set
    var set = themes[theme] || themes['standard'];

    // Add our palette to the palette
    set.palette.colors = {
        red: colorBlend('#F44336', p1 || color, blendLevel),
        pink: colorBlend('#E91E63', p1 || color, blendLevel),
        purple: colorBlend('#9C27B0', p1 || color, blendLevel),
        deep_purple: colorBlend('#673AB7', p1 || color, blendLevel),
        indigo: colorBlend('#3F51B5', p1 || color, blendLevel),
        blue: colorBlend('#2196F3', p1 || color, blendLevel),
        light_blue: colorBlend('#03A9F4', p1 || color, blendLevel),
        cyan: colorBlend('#00BCD4', p1 || color, blendLevel),
        teal: colorBlend('#009688', p1 || color, blendLevel),
        green: colorBlend('#4CAF50', p1 || color, blendLevel),
        light_green: colorBlend('#8BC34A', p1 || color, blendLevel),
        lime: colorBlend('#CDDC39', p1 || color, blendLevel),
        yellow: colorBlend('#FFEB3B', p1 || color, blendLevel),
        amber: colorBlend('#FFC107', p1 || color, blendLevel),
        orange: colorBlend('#FF9800', p1 || color, blendLevel),
        deep_orange: colorBlend('#FF5722', p1 || color, blendLevel),
        brown: colorBlend('#795548', p1 || color, blendLevel),
        blue_grey: colorBlend('#607D8B', p1 || color, 1),
        grey: '#9E9E9E'
    };

    // Return whichever set we concluded
    return set;
};

/**
 * @var transition The animation transition to use across styles
 */
var transitionAnimation = ['450ms', 'cubic-bezier(0.23, 1, 0.32, 1)', '0ms'].join(' ');
var transition = 'all ' + transitionAnimation;

/**
 * @type Material UI theme settings
 */
var getMui = function getMui(theme, palette) {
    // Declare and initialize
    var theme = getThemeSet(theme || 'standard', palette);

    // Return the theme
    return (0, _getMuiTheme2.default)(theme);
};

/**
 * @var baseTheme The base styles for the Work Orders system
 */
var baseTheme = function baseTheme(mui) {
    var _ref;

    // Declare and initialize
    var priorityBlendLevel = 1;
    var statusBlendLevel = .65;

    // Map out color changes
    var p1 = mui.palette.primary1Color || color;
    var luma = (0, _colorManipulator.getLuminance)(p1);
    var p1alt = luma > .2 ? (0, _colorManipulator.darken)(p1, .05) : (0, _colorManipulator.lighten)(p1, .05);
    var p1text = luma > .5 ? (0, _colorManipulator.darken)(p1, .6) : (0, _colorManipulator.lighten)(p1, .99);

    // Return the bulk of our theme
    return _ref = {
        absoluteRight: {
            position: 'absolute',
            top: '50%',
            right: 8,
            zIndex: 100,
            WebkitTransform: 'translateY(-50%)',
            transform: 'translateY(-50%)'
        },
        actionButtons: {
            textAlign: 'right',
            marginTop: 16
        },
        activePrimary: {
            backgroundColor: p1,
            color: p1text
        },
        alertError: {
            borderBottom: '1px solid',
            borderBottomColor: _colors.red400,
            textAlign: 'center',
            fontSize: 14,
            color: _colors.red400,
            margin: 8,
            padding: 16,
            paddingBottom: 8
        },
        alertPrimary: {
            borderBottom: '1px solid',
            borderBottomColor: p1,
            textAlign: 'center',
            fontSize: 14,
            color: p1,
            margin: 8,
            padding: 16,
            paddingBottom: 8
        },
        appBar: _extends({}, mui.appBar, {
            position: 'fixed',
            boxShadow: 'none',
            color: p1,
            top: 0,
            width: '100%',
            padding: '0 0 0 280px'
        }),
        appSwitcherMenuContainer: {
            display: 'flex',
            WebkitAlignItems: 'center',
            alignItems: 'center'
        },
        appSwitcherMenu: {
            fontSize: 24,
            height: 'auto'
        },
        appSwitcherMenuIcon: {},
        appSwitcherMenuLabel: {
            textDecoration: 'none',
            paddingLeft: 0
        },
        appSwitcherMenuUnderline: {
            display: 'none'
        },
        attachmentTitle: {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
            paddingBottom: 1,
            overflow: 'hidden'
        },
        attachmentSubtitle: {
            fontSize: 12,
            color: mui.palette.secondaryTextColor || textColor
        },
        avatarButton: {
            width: 72,
            height: 72,
            marginTop: -12
        },
        badgeInline: {
            marginBottom: -6,
            marginLeft: 4
        },
        bg: _extends({}, mui.bg, {
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: mui.palette.backgroundColor
        }),
        boxedIn: {
            position: 'relative',
            margin: 32
        },
        buttonGroup: {
            display: 'flex',
            padding: 16
        },
        buttonGroupButton: {
            lineHeight: 2,
            minWidth: 0,
            width: 48
        },
        buttonGroupIcon: {
            lineHeight: 2
        },
        buttonRight: {
            position: 'absolute',
            right: 24
        },
        buttonToggleContainer: {
            display: 'flex',
            marginBottom: 16
        },
        buttonToggle: {
            WebkitFlexGrow: 1,
            flexGrow: 1,
            textAlign: 'center'
        },
        cardActions: {
            position: 'relative',
            top: 16,
            right: 0,
            textAlign: 'right',
            paddingRight: 24
        },
        cardContentContainer: {
            display: 'flex'
        },
        cardContentLeft: {
            textAlign: 'center',
            WebkitFlex: '0 0 160px',
            flex: '0 0 160px',
            width: 160,
            paddingTop: 16,
            paddingRight: 16
        },
        cardContentRight: {
            WebkitFlexGrow: 1,
            flexGrow: 1
        },
        cardList: {
            position: 'relative',
            marginTop: 0,
            marginRight: 24,
            marginBottom: 0,
            marginLeft: 24,
            paddingTop: 12,
            paddingBottom: 24
        },
        centerMiddle: {
            textAlign: 'center',
            verticalAlign: 'middle'
        },
        chipLabel: {
            cursor: 'pointer',
            fontSize: 10,
            textTransform: 'uppercase',
            lineHeight: '12px',
            paddingLeft: 8,
            paddingRight: 8,
            verticalAlign: '1px'
        },
        chipSetContainer: {
            display: 'flex',
            WebkitAlignItems: 'center',
            alignItems: 'center'
        },
        chipSet: {
            display: 'flex',
            flexGrow: 1,
            flexWrap: 'wrap'
        },
        chipSetChip: {
            marginRight: 4,
            marginBottom: 4
        },
        commentAuthor: {
            display: 'inline-block',
            fontSize: 16,
            color: mui.palette.textColor
        },
        commentDate: {
            display: 'inline-block',
            fontSize: 14,
            color: mui.palette.secondaryTextColor,
            marginTop: 8,
            marginBottom: 8,
            marginLeft: 8
        },
        commentActionButton: {
            float: 'left'
        },
        commentContentContainer: {
            lineHeight: '24px',
            whiteSpace: 'pre-line',
            height: 'auto',
            paddingRight: 24
        },
        copyright: {
            textAlign: 'center',
            fontSize: 12,
            color: p1text,
            marginTop: 32,
            padding: 16
        },
        cropComponent: {
            maxHeight: 350,
            width: '100%',
            height: '100%'
        },
        cropContainer: {
            display: 'block'
        },
        cropPreviewContainer: {
            textAlign: 'center',
            marginTop: 24
        },
        cropPreview: {
            borderRadius: '50%',
            marginBottom: 8,
            width: 96,
            height: 96,
            margin: '0 auto',
            overflow: 'hidden'
        },
        cropPreviewLabel: {
            fontSize: 12,
            textTransform: 'uppercase',
            marginTop: 16
        },
        dataTableCell: {
            width: '1%'
        },
        datePicker: _extends({}, mui.datePicker, {
            selectColor: p1 || color
        }),
        demoBlock: {
            color: mui.palette.textColor,
            padding: 16
        },
        descriptionText: {
            fontSize: 12,
            color: mui.palette.secondaryTextColor || textColor
        },
        dialogCard: {
            padding: 0,
            paddingTop: 0
        },
        dialogCardBody: {
            padding: 0
        },
        dialogCardContent: {
            width: 'calc(100% - 32px)'
        },
        dialogCardContentSmall: {
            maxWidth: 512
        },
        dialogContent: {
            top: -40,
            width: 'calc(100% - 16px)'
        },
        dividerFlush: {
            marginTop: 12,
            marginRight: -16,
            marginBottom: 12,
            marginLeft: -16
        },
        drawer: _extends({}, mui.drawer, {
            borderRight: '1px solid',
            borderRightColor: mui.palette.lineColor,
            boxShadow: 'none',
            zIndex: 1500
        }),
        drawerButtonContainer: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            paddingTop: 24,
            paddingRight: 16,
            paddingBottom: 8,
            paddingLeft: 16
        },
        drawerButton: {
            display: 'block',
            color: p1text || textColor,
            margin: '0 auto'
        },
        drawerButtonCancel: {
            display: 'block',
            margin: '0 auto'
        },
        drawerButtonLabel: {
            color: p1text || textColor
        },
        dropdownBar: {
            display: 'flex'
        },
        dropdownIcon: {
            verticalAlign: 'middle'
        },
        dropdownMenuTitle: {
            fontSize: 12,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            lineHeight: '48px',
            color: mui.palette.darkBlack,
            padding: '0 16px'
        },
        empty: {
            fontStyle: 'italic',
            color: _colors.grey400
        },
        errorBackground: {
            backgroundColor: _colors.red400
        },
        errorText: {
            color: _colors.red400
        },
        fieldReadOnly: {
            opacity: 0.5
        },
        filterDateRangeContainer: {
            marginBottom: 16
        },
        filterRadioItem: {
            marginBottom: 16
        },
        filterRadioSelect: {
            marginBottom: 16
        },
        filterToggleItem: {
            marginBottom: 16
        },
        flexContainer: {
            display: 'flex',
            padding: 16
        },
        flexContainerBreak: {
            display: 'flex',
            WebkitAlignItems: 'flex-start',
            alignItems: 'flex-start'
        },
        flexContainerFluid: {
            display: 'flex',
            WebkitAlignItems: 'center',
            alignItems: 'center'
        },
        flexContainerFluidLeft: {
            WebkitFlexGrow: 1,
            flexGrow: 1,
            marginRight: 12
        },
        flexContainerFluidRight: {
            WebkitFlexGrow: 1,
            flexGrow: 1,
            marginLeft: 12
        },
        floatingLabel: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        },
        flush: {
            margin: 0,
            padding: 0
        },
        helpText: {
            fontSize: 12,
            fontStyle: 'italic'
        },
        hide: {
            display: 'none'
        },
        icons: 'material-icons',
        infoSlideContainer: {
            display: 'flex',
            padding: 16
        },
        infoSlideFields: {
            WebkitFlex: '0 0 256px',
            flex: '0 0 256px',
            width: 256,
            marginRight: 32
        },
        infoSlideDescription: {
            WebkitFlexGrow: 1,
            flexGrow: 1
        },
        inlineEditIconButton: {
            width: 32,
            height: 32,
            padding: 0,
            float: 'right',
            verticalAlign: 'middle'
        },
        inlineEditIcon: {
            fontSize: 24
        },
        inlineIcon: {
            fontSize: 16,
            color: p1 || color,
            marginRight: 4,
            verticalAlign: 'middle'
        },
        inputError: {
            borderTop: '2px solid',
            borderTopColor: _colors.red400,
            fontSize: 12,
            color: _colors.red400,
            marginTop: 8,
            paddingTop: 4
        },
        inputLabel: {
            userSelect: 'none',
            position: 'relative',
            top: 20,
            WebkitTransition: transition,
            transition: transition,
            zIndex: 1,
            WebkitTransform: 'scale(0.75) translate(0px, -28px)',
            transform: 'scale(0.75) translate(0px, -28px)',
            lineHeight: '22px',
            pointerEvents: 'none',
            color: mui.textField.floatingLabelColor,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            WebkitTransformOrigin: 'left top 0px',
            transformOrigin: 'left top 0px'
        },
        labelStyle: {},
        link: {
            textDecoration: 'none',
            color: p1
        },
        loadCover: {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 100,
            display: 'flex',
            WebkitJustifyContent: 'center',
            justifyContent: 'center',
            background: (0, _colorManipulator.fade)(mui.palette.backgroundColor, 0.5),
            paddingTop: 64
        },
        loadCoverRelative: {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 100,
            display: 'flex',
            WebkitJustifyContent: 'center',
            justifyContent: 'center',
            WebkitAlignItems: 'center',
            alignItems: 'center',
            background: (0, _colorManipulator.fade)(mui.palette.backgroundColor, 0.5)
        },
        listBack: {
            width: 48,
            height: 48,
            verticalAlign: 'middle',
            color: _colors.fullWhite,
            marginTop: 8,
            marginLeft: 8
        },
        listBackIcon: {},
        listFooter: {
            display: 'flex',
            WebkitAlignItems: 'center',
            alignItems: 'center',
            padding: '16px 48px 48px'
        },
        listFooterLabel: {
            fontStyle: 'italic',
            fontSize: 14,
            color: mui.palette.disabledColor
        },
        listHeader: {
            display: 'flex',
            WebkitAlignItems: 'center',
            alignItems: 'center',
            padding: '24px 48px 0 32px'
        },
        listTitle: {
            lineHeight: '24px',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
            overflow: 'hidden'
        },
        logo: {
            display: 'inline-block',
            textAlign: 'center',
            width: '100%'
        },
        maxWidth: {
            position: 'relative',
            maxWidth: 752,
            margin: '0 auto'
        },
        menuIconMenu: {
            position: 'absolute',
            top: 8,
            right: 8
        },
        menuIconMenuIcon: {
            color: _colors.fullWhite
        },
        menuLink: {
            textDecoration: 'none',
            color: mui.palette.textColor,
            padding: '8px 0'
        },
        modalDatePicker: {},
        modalProgress: {
            width: 'calc(100% - 48px)',
            margin: '0 24px 24px'
        },
        modalTimePicker: {},
        mobileButton: {
            maxWidth: 256,
            padding: '24px 24px 0'
        },
        mobileFlexWrap: {
            display: 'flex'
        },
        palette: _extends({}, mui.palette, {
            primaryOffset: p1text || textColor,
            successColor: _colors.green500,
            failColor: _colors.red400
        }),
        paperBlock: {
            margin: 32,
            padding: 32
        },
        paperBlockFlushed: {
            margin: 32,
            padding: 0
        },
        permissionButton: {
            width: '25%',
            height: 'auto',
            marginBottom: 16,
            paddingTop: 8
        },
        permissionControl: {
            textAlign: 'center',
            minWidth: '33.333%',
            marginRight: 16
        },
        permissionForm: {
            display: 'flex',
            WebkitFlexWrap: 'wrap',
            flexWrap: 'wrap'
        },
        permissionIcon: {
            display: 'block',
            fontSize: 32,
            marginLeft: 0
        },
        permissionItem: {
            WebkitAlignItems: 'center',
            alignItems: 'center',
            padding: '8px 0'
        },
        permissionPresetDescription: {
            fontSize: 12,
            marginTop: 4,
            marginBottom: 32
        },
        permissionPresetPrompt: {
            fontSize: 12,
            marginTop: 4,
            marginBottom: 4
        },
        permissionPresetSlider: {
            marginTop: 24,
            marginBottom: 24
        },
        positionTopLeft: {
            position: 'absolute',
            top: 0,
            left: 4
        },
        positionTopRight: {
            position: 'absolute',
            top: 0,
            right: 4
        },
        primaryBg: {
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: p1
        },
        primaryText: {
            color: p1text,
            WebkitTextFillColor: p1text
        },
        priorityColors: {
            0: colorBlend(_colors.grey600, p1 || color, priorityBlendLevel),
            1: colorBlend(_colors.lightGreen500, p1 || color, priorityBlendLevel),
            2: colorBlend(_colors.yellow700, p1 || color, priorityBlendLevel),
            3: colorBlend(_colors.orange600, p1 || color, priorityBlendLevel),
            4: colorBlend(_colors.red400, p1 || color, priorityBlendLevel)
        },
        raisedButton: _extends({}, mui.raisedButton, {
            textColor: p1text || textColor
        }),
        resourceCard: {
            position: 'fixed',
            right: 0,
            left: 0,
            margin: 24,
            opacity: 0,
            WebkitTransform: 'translateX(calc(100% + 24px))',
            transform: 'translateX(calc(100% + 24px))',
            overflow: 'hidden',
            backfaceVisibility: 'hidden'
        },
        resourceList: {
            position: 'fixed',
            top: 64,
            right: 0,
            bottom: 0,
            left: 256,
            backgroundColor: 'transparent',
            opacity: 1,
            overflowY: 'scroll',
            WebkitOverflowScrolling: 'touch',
            backfaceVisibility: 'hidden'
        },
        risingButton: {
            position: 'absolute',
            top: 0,
            right: 16,
            zIndex: 200,
            WebkitTransform: 'translateY(-50%)',
            transform: 'translateY(-50%)'
        },
        risingButtonLow: {
            position: 'absolute',
            top: 36,
            right: 16,
            zIndex: 200,
            WebkitTransform: 'translateY(50%)',
            transform: 'translateY(50%)'
        },
        risingButtonGroup: {
            position: 'absolute',
            top: -32,
            right: 16,
            zIndex: 200,
            WebkitTransform: 'translateY(-50%)',
            transform: 'translateY(-50%)'
        },
        risingButtonGroupButton: {
            marginLeft: 8
        },
        roleFormContainer: {
            position: 'relative',
            paddingTop: 16
        },
        saveButtons: {
            padding: 16
        },
        searchButtonContainer: {
            display: 'flex'
        },
        searchButton: {
            color: p1text || textColor
        },
        searchButtonIcon: {
            color: p1text || textColor
        },
        searchButtonForm: {
            display: 'flex'
        },
        searchButtonField: {
            WebkitTransition: transition,
            transition: transition
        },
        searchButtonInput: {
            color: p1text || textColor
        },
        searchButtonUnderline: {
            borderColor: p1text || textColor
        },
        secondaryText: {
            overflow: 'hidden',
            margin: '4px 0 0',
            color: mui.palette.secondaryTextColor || textColor,
            lineHeight: '16px',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '14px',
            width: '100%',
            height: '16px'
        },
        secondaryTextFluid: {
            overflow: 'hidden',
            margin: '4px 0 0',
            color: mui.palette.secondaryTextColor || textColor,
            lineHeight: '16px',
            fontSize: '14px',
            width: '100%'
        },
        settingsModal: {
            padding: 0,
            paddingTop: 0
        },
        settingsModalContent: {
            width: 'calc(100% - 32px)',
            padding: 0
        },
        settingsModalBody: {
            padding: 0
        },
        shiftViewList: {
            height: '100%',
            WebkitTransform: 'translateX(0)',
            transform: 'translateX(0)',
            WebkitTransition: transition,
            transition: transition,
            width: '100%',
            marginBottom: 24,
            overflow: 'hidden'
        },
        shiftViewSingle: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            width: '66.7%',
            height: '100%',
            WebkitTransform: 'translateX(200%)',
            transform: 'translateX(200%)',
            WebkitTransition: transition,
            transition: transition,
            overflowY: 'scroll',
            WebkitOverflowScrolling: 'touch'
        },
        slides: {
            overflow: 'visible',
            paddingBottom: 24
        },
        slide: {
            position: 'relative'
        },
        slideInner: {
            overflowX: 'visible',
            overflowY: 'visible !important'
        },
        slideViewList: {
            height: '100%',
            WebkitTransform: 'translateX(0)',
            transform: 'translateX(0)',
            WebkitTransition: transition,
            transition: transition,
            marginBottom: 24,
            overflowY: 'scroll',
            WebkitOverflowScrolling: 'touch'
        },
        slideViewOptions: {
            height: '100%',
            WebkitTransform: 'translateX(0)',
            transform: 'translateX(0)',
            WebkitTransition: transition,
            transition: transition,
            marginBottom: 24,
            overflowY: 'scroll',
            WebkitOverflowScrolling: 'touch'
        },
        slideViewSingle: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '100%',
            WebkitTransform: 'translateX(100%)',
            transform: 'translateX(100%)',
            WebkitTransition: transition,
            transition: transition,
            overflowY: 'scroll',
            WebkitOverflowScrolling: 'touch'
        },
        slideViewSlide: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            WebkitTransform: 'translateX(100%)',
            transform: 'translateX(100%)',
            WebkitTransition: transition,
            transition: transition
        },
        statusColors: {
            red: colorBlend('#F44336', p1 || color, statusBlendLevel),
            pink: colorBlend('#E91E63', p1 || color, statusBlendLevel),
            purple: colorBlend('#9C27B0', p1 || color, statusBlendLevel),
            deep_purple: colorBlend('#673AB7', p1 || color, statusBlendLevel),
            indigo: colorBlend('#3F51B5', p1 || color, statusBlendLevel),
            blue: colorBlend('#2196F3', p1 || color, statusBlendLevel),
            light_blue: colorBlend('#03A9F4', p1 || color, statusBlendLevel),
            cyan: colorBlend('#00BCD4', p1 || color, statusBlendLevel),
            teal: colorBlend('#009688', p1 || color, statusBlendLevel),
            green: colorBlend('#4CAF50', p1 || color, statusBlendLevel),
            light_green: colorBlend('#8BC34A', p1 || color, statusBlendLevel),
            lime: colorBlend('#CDDC39', p1 || color, statusBlendLevel),
            yellow: colorBlend('#FFEB3B', p1 || color, statusBlendLevel),
            amber: colorBlend('#FFC107', p1 || color, statusBlendLevel),
            orange: colorBlend('#FF9800', p1 || color, statusBlendLevel),
            deep_orange: colorBlend('#FF5722', p1 || color, statusBlendLevel),
            brown: colorBlend('#795548', p1 || color, statusBlendLevel),
            blue_grey: colorBlend('#607D8B', p1 || color, 1),
            grey: '#9E9E9E'
        },
        subtitleBar: {
            display: 'flex',
            backgroundColor: mui.palette.canvasDarkerColor,
            color: mui.palette.secondaryTextColor || textColor,
            padding: '8px 16px'
        },
        subtitleBarSection: {
            display: 'flex',
            WebkitAlignItems: 'center',
            alignItems: 'center',
            WebkitJustifyContent: 'center',
            justifyContent: 'center'
        },
        subtitleDataIcon: {
            margin: '0 8px',
            verticalAlign: 'middle'
        },
        subtitleLabel: {
            lineHeight: '48px',
            minWidth: 0,
            height: 48,
            paddingLeft: 16,
            paddingRight: 16
        },
        subtitleButton: {
            position: 'relative',
            height: 48
        },
        subtitleDataIconSmall: {
            fontSize: 12,
            lineHeight: '24px',
            margin: '0 8px',
            verticalAlign: 'middle'
        },
        tabs: _extends({}, mui.tabs, {
            color: mui.palette.darkBlack,
            textColor: _colors.fullWhite,
            selectedtextColor: _colors.fullWhite
        }),
        tabInkBar: {
            backgroundColor: _colors.fullWhite
        },
        tableLink: {
            textDecoration: 'none',
            color: color
        },
        tag: {
            display: 'inline-block',
            borderRadius: 4,
            fontSize: 10,
            textTransform: 'uppercase',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 96,
            margin: '0 4px',
            padding: '0 4px',
            verticalAlign: 'middle',
            overflow: 'hidden'
        },
        termFormContainer: {
            position: 'relative',
            marginTop: 16
        },
        textEditorContainer: {
            position: 'relative',
            marginTop: 0,
            marginBottom: 16,
            padding: 0
        },
        textOverflow: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
        },
        textTrunc: {
            width: '90%',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        timePicker: _extends({}, mui.timePicker, {
            headerColor: p1 || color
        }),
        title: {
            fontSize: 24,
            textOverflow: 'ellipsis',
            marginBottom: 16,
            padding: '0 24px'
        },
        titlebar: {
            padding: '16px 48px 0 8px'
        },
        titleInput: {
            textOverflow: 'ellipsis',
            textShadow: '1px 1px 0 rgba(0,0,0,.25)',
            color: _colors.fullWhite,
            WebkitTextFillColor: _colors.fullWhite
        }
    }, _defineProperty(_ref, 'titleInput', {
        textOverflow: 'ellipsis'
    }), _defineProperty(_ref, 'titleInputHint', {}), _defineProperty(_ref, 'titleUnderline', {
        bottom: -6,
        borderColor: 'transparent'
    }), _defineProperty(_ref, 'titleUnderlineFocus', {
        position: 'relative',
        marginTop: 8
    }), _defineProperty(_ref, 'topBarProgress', {
        position: 'absolute',
        top: 60,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 9999
    }), _defineProperty(_ref, 'transition', transition), _defineProperty(_ref, 'transitionAnimation', transitionAnimation), _defineProperty(_ref, 'transitionHeight', 'height ' + transitionAnimation), _defineProperty(_ref, 'transitionWidth', 'width ' + transitionAnimation), _defineProperty(_ref, 'updateListLabel', {
        lineHeight: 1.25
    }), _defineProperty(_ref, 'userCardTitleExpanded', {
        fontSize: 24
    }), _defineProperty(_ref, 'userCardDataWrap', {
        display: 'flex',
        WebkitFlexWrap: 'wrap',
        flexWrap: 'wrap'
    }), _defineProperty(_ref, 'userCardData', {
        width: '50%',
        paddingRight: 16,
        paddingLeft: 16
    }), _defineProperty(_ref, 'userCardDataFull', {
        width: '100%',
        paddingRight: 16,
        paddingLeft: 16
    }), _defineProperty(_ref, 'userCardDataReadOnly', {
        width: '50%',
        paddingRight: 16,
        paddingLeft: 16,
        opacity: 0.5
    }), _defineProperty(_ref, 'userCardFields', {
        padding: 16,
        paddingTop: 0
    }), _defineProperty(_ref, 'userCardGroups', {
        padding: 16
    }), _defineProperty(_ref, 'userCardInfo', {
        flexGrow: 1
    }), _defineProperty(_ref, 'verticalSpacing', {
        marginTop: 12,
        marginBottom: 12
    }), _defineProperty(_ref, 'verticalSpacingLarge', {
        marginTop: 32,
        marginBottom: 32
    }), _defineProperty(_ref, 'viewBox', {
        boxShadow: 'none',
        borderRadius: 8,
        padding: 16
    }), _defineProperty(_ref, 'viewBoxContainer', {
        position: 'relative',
        top: 0,
        left: '50%',
        maxWidth: 640,
        width: '100%',
        marginTop: 64,
        WebkitTransform: 'translateX(-50%)',
        transform: 'translateX(-50%)'
    }), _defineProperty(_ref, 'viewContainer', {
        position: 'absolute',
        top: 64,
        left: 256,
        right: 0,
        WebkitTransition: transition,
        transition: transition,
        overflow: 'hidden'
    }), _defineProperty(_ref, 'viewContainerFlat', {
        position: 'absolute',
        top: 64,
        left: 256,
        right: 0,
        bottom: 0,
        WebkitTransition: transition,
        transition: transition,
        overflow: 'hidden'
    }), _defineProperty(_ref, 'viewContainerFlex', {}), _defineProperty(_ref, 'viewContainerFull', {
        position: 'absolute',
        top: 64,
        left: 0,
        right: 0,
        WebkitTransition: transition,
        transition: transition,
        overflow: 'hidden'
    }), _defineProperty(_ref, 'viewContainerFullFlat', {
        position: 'relative',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        WebkitTransition: transition,
        transition: transition,
        overflow: 'hidden'
    }), _ref;
};

/**
 * @var listView Theme styles for the "list" view of work orders
 */
var listView = function listView(baseTheme) {};

/**
 * @var singleView Theme styles for the "single" view of work orders
 */
var singleView = function singleView(baseTheme) {
    return {
        resourceList: _extends({}, baseTheme.resourceList, {
            left: 288,
            opacity: 0,
            pointerEvents: 'none'
        }),
        resourceCard: _extends({}, baseTheme.resourceCard, {
            position: 'relative',
            right: 0,
            left: 0,
            opacity: 1,
            WebkitTransform: 'translateX(0)',
            transform: 'translateX(0)'
        }),
        shiftViewList: _extends({}, baseTheme.shiftViewList, {
            width: '33.33%'
        }),
        shiftViewSingle: _extends({}, baseTheme.shiftViewSingle, {
            WebkitTransform: 'translateX(50%)',
            transform: 'translateX(50%)'
        }),
        slideViewList: _extends({}, baseTheme.slideViewList, {
            WebkitTransform: 'translateX(-100%)',
            transform: 'translateX(-100%)'
        }),
        slideViewOptions: _extends({}, baseTheme.slideViewList, {
            position: 'absolute',
            WebkitTransform: 'translateX(-100%)',
            transform: 'translateX(-100%)',
            overflow: 'hidden'
        }),
        slideViewSingle: _extends({}, baseTheme.slideViewSingle, {
            WebkitTransform: 'translateX(0)',
            transform: 'translateX(0)'
        }),
        slideViewSlide: _extends({}, baseTheme.slideViewSlide, {
            position: 'relative',
            WebkitTransform: 'translateX(0)',
            transform: 'translateX(0)'
        })
    };
};

/**
 * @var singleViewFull Theme styles for the "single" view without sidebar
 */
var listViewFull = function listViewFull(baseTheme) {
    return {
        appBar: _extends({}, baseTheme.appBar, {
            padding: '0 0 0 24px'
        }),
        viewContainer: _extends({}, baseTheme.viewContainer, {
            left: 0
        }),
        viewContainerFlat: _extends({}, baseTheme.viewContainerFlat, {
            left: 0
        }),
        resourceList: _extends({}, baseTheme.resourceList, {
            left: 0
        })
    };
};

/**
 * @var listViewFull Theme styles for the "list" view without sidebar
 */
var singleViewFull = function singleViewFull(baseTheme) {
    return {
        appBar: _extends({}, baseTheme.appBar, {
            padding: '0 0 0 24px'
        }),
        viewContainer: _extends({}, baseTheme.viewContainer, {
            left: 0
        }),
        viewContainerFlat: _extends({}, baseTheme.viewContainerFlat, {
            left: 0
        })
    };
};

/**
 * Modify a given theme definition block for small screens.
 *
 * Because of the multi-level, complex nature of style definitions before we
 * reach this point, we are currently applying styles from within a method
 * so that we are able to use dynamic parameters instead of previously
 * defined constants.
 *
 * @since 0.0.2
 * @method viewSmall
 * @param object theme Processed theme object
 * @return object Modified theme styles for small screens
 */
var viewSmall = function viewSmall(theme) {
    // Definen our small screen styles
    var mods = {
        boxedIn: _extends({}, theme.boxedIn, {
            margin: 0
        }),
        cardContentContainer: {
            display: 'block'
        },
        cardContentLeft: {
            textAlign: 'center',
            width: '100%',
            paddingRight: 0
        },
        cardContentRight: {
            paddingRight: 0
        },
        commentActionButton: {
            marginBottom: 16,
            float: 'none'
        },
        commentActionButtons: {
            display: 'block',
            textAlign: 'center',
            marginTop: 16
        },
        commentDate: {
            display: 'block',
            fontSize: 14,
            color: theme.palette.secondaryTextColorColor,
            marginLeft: 0,
            marginTop: 4
        },
        cropComponent: {
            maxHeight: 350,
            width: '100%',
            height: '100%'
        },
        cropContainer: {
            display: 'block'
        },
        cropPreview: {
            WebkitFlex: '0 0 96px',
            flex: '0 0 96px',
            borderRadius: '50%',
            margin: '24px auto',
            width: 96,
            height: 96,
            overflow: 'hidden'
        },
        dialogContent: {
            top: -48,
            width: 'calc(100% - 48px)'
        },
        drawer: _extends({}, theme.drawer, {
            top: 0,
            height: '100%'
        }),
        flexContainerBreak: _extends({}, theme.flexContainerBreak, {
            display: 'block',
            textAlign: 'center'
        }),
        infoSlideContainer: _extends({}, theme.infoSlideContainer, {
            flexWrap: 'wrap'
        }),
        infoSlideFields: _extends({}, theme.infoSlideFields, {
            WebkitFlex: 'inherit',
            flex: 'inherit',
            width: '100%',
            marginRight: 0,
            order: 2
        }),
        infoSlideDescription: _extends({}, theme.infoSlideDescription, {
            order: 1
        }),
        listFooter: {
            display: 'block',
            padding: 16,
            marginBottom: 16
        },
        listFooterLabel: {
            textAlign: 'center',
            fontStyle: 'italic',
            fontSize: 14,
            color: theme.palette.disabledColor,
            marginBottom: 16
        },
        listHeader: _extends({}, theme.listHeader, {
            padding: 16,
            paddingBottom: 0,
            marginTop: 0
        }),
        listTitle: {
            lineHeight: '24px',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
            overflow: 'hidden'
        },
        mobileButton: _extends({}, theme.mobileButton, {}),
        mobileFixedFooter: {
            position: 'fixed',
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1300
        },
        mobileFixedFooterWrap: {
            display: 'flex',
            WebkitAlignItems: 'center',
            alignItems: 'center',
            WebkitJustifyContent: 'center',
            justifyContent: 'center',
            padding: 16
        },
        mobileFlexWrap: {
            WebkitFlexWrap: 'wrap',
            flexWrap: 'wrap'
        },
        mobileModal: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            margin: 16,
            overflowY: 'hidden'
        },
        modalDatePicker: {
            marginTop: -38
        },
        modalTimePicker: {
            minHeight: 380,
            marginTop: -64
        },
        noResultsViewContainer: {
            WebkitTransform: 'translate(-50%, 0)',
            transform: 'translate(-50%, 0)'
        },
        pageButtonContainer: _extends({}, theme.pageButtonContainer, {
            display: 'flex',
            margin: 0
        }),
        paperBlockFlushed: _extends({}, theme.paperBlockFlushed, {
            margin: 0
        }),
        paperBlock: _extends({}, theme.paperBlock, {
            marginTop: 32,
            margin: 0
        }),
        permissionButton: {
            width: '50%',
            height: 'auto',
            paddingTop: 8
        },
        permissionControl: {
            textAlign: 'right',
            width: '100%'
        },
        permissionIcon: {
            display: 'block',
            fontSize: 32,
            marginLeft: 0
        },
        permissionItem: {
            display: 'block',
            padding: '8px 0'
        },
        resourceCard: _extends({}, theme.resourceCard, {
            margin: 0
        }),
        sortMenuContainer: {
            textAlign: 'right'
        },
        tabButton: {
            display: 'block'
        },
        title: _extends({}, theme.title, {
            marginBottom: 0
        }),
        titlebar: _extends({}, theme.titlebar, {
            padding: '24px 48px 0 8px'
        }),
        topMenuContainer: _extends({}, theme.topMenuContainer, {
            position: 'absolute',
            top: 12,
            right: 0
        }),
        userCardData: {
            width: '100%',
            paddingRight: 4,
            paddingLeft: 4
        },
        userCardDataWrap: {
            display: 'block'
        }
    };

    // Return with gifts
    return _extends({}, theme, mods);
};

/**
 * Modify a given theme definition block for tiny screens.
 *
 * Small screens include up to the size of a portrait iPad level. Sometimes we
 * block out some elements for super small screens that we could actually
 * leave along for the "small" size. We can reasonably assume that this
 * size will mostly cover phone sizes.
 *
 * @since 0.0.2
 * @method viewTiny
 * @param object theme Processed theme object
 * @return object Modified theme styles for small screens
 */
var viewTiny = function viewTiny(theme) {
    // Definen our small screen styles
    var mods = {
        cardList: {
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            paddingTop: 12,
            paddingBottom: 24
        },
        dialogContent: {
            top: -48,
            width: 'calc(100% - 24px)'
        },
        slides: {
            marginBottom: 64,
            overflow: 'hidden'
        },
        subtitleBar: _extends({}, theme.subtitleBar, {
            whiteSpace: 'nowrap',
            overflowX: 'auto'
        }),
        subtitleBarSection: _extends({}, theme.subtitleBarSection, {
            display: 'block',
            fontSize: 14,
            lineHeight: '48px',
            padding: 0,
            verticalAlign: 'middle'
        })
    };

    // Return with gifts
    return _extends({}, theme, mods);
};

/**
 * Get work order theme styles.
 *
 * When we call this function to obtain theme style settings, we accept the
 * active view and screensize to account for various user viewports.
 *
 * @since 0.0.2
 * @method getTheme
 * @param string view The active view styles we are attempting to pull
 * @param int viewport The size of the viewport
 * @param bool full Sidebar state flag
 * @param object set The theme object
 * @return object Theme settings
 */
var getTheme = function getTheme(theme, view, full, set) {
    // Declare and initialize
    var mui = getMui(set, theme);
    var base = baseTheme(mui);
    var dims = p3.viewport.getDimensions();
    var views = ['list', 'single'];
    var theme = _extends({}, mui, base);
    var mods = { base: {}, view: {} };
    var isSmall = p3.viewport.isSmall();
    var isTiny = p3.viewport.isTiny();

    // Always assume full view on smaller screens
    if (isSmall) full = true;

    // If there is a view supplied, modify our theme
    switch (view) {
        case 'list':
            mods = {
                base: listView(base),
                view: listViewFull(base)
            };
            break;
        case 'single':
            mods = {
                base: singleView(base),
                view: singleViewFull(base)
            };
            break;
    }

    // Apply any default mods
    theme = _extends({}, theme, mods.base);

    // Apply mods based on active view
    if (full) theme = _extends({}, theme, mods.view);

    // Apply mods based on screen size
    if (isSmall) theme = viewSmall(theme);
    if (isTiny) theme = viewTiny(theme);

    // Throw in the dimensions with our theme
    theme.dims = dims;

    // Impose the theme set declaration
    theme.themeSet = set;

    // Throw yo hands up
    return theme;
};

// POKEBALL GO!
exports.default = getTheme;


//////////////////
// WEBPACK FOOTER
// ./src/_themes/Base.js
// module id = 283
// module chunks = 7